export default {
  currentCustomer: null,
  // EditPrio in Showing component
  customerEditPrio: null,
  currentShowing: null,
  currentShowingsSlot: {},
  currentData: {},
  currentListingWithActiveShowing: null,
  allRecentListingsWithoutActiveShowing: [],
  allListingsWithActiveShowing: [],
}
